import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import fieldActions from '../modules/fields/fields-actions'
import StandardInput from './standard-input'
import SelectionInput from './selection-input'
import MultiSelectionInput from './multi-selection-input'
import CheckBoxInput from './checkbox-input'
import YesNoInput from './yes-no-input'
import DatePicker from './date-picker'
import YesNoOptions from '../options/yes-no-options'
import CheckOptions from '../options/check-options'
import SuburbAutoComplete from './suburb-auto-complete'
import PostcodeAutoComplete from './postcode-auto-complete'
import { withForm } from '../modules/form'
import { get, has } from 'lodash';



const mapStateToProps = (state, initialState) => ({
    ...initialState,
    state,
    fields: state.fields,
    errors: state.errors,
    form: state.form,
})


const mapDispatchToProps = dispatch => ({
    actions: {
        ...bindActionCreators({
            ...fieldActions
        }, dispatch) 
    }
})


export default connect(mapStateToProps, mapDispatchToProps)(class extends React.Component<any, any>{


    render(){
        const field = this.props.field;
        const fields = this.props.fields;
        const type = this.props.type ? this.props.type : "String";
        const form = this.props.form;
        const formData = this.props.form.getData();
        const isInferred = has(formData.inferred, field);
        const intercept = this.props.intercept;
        
        const childProps = {
            ...this.props,
            field,
            value: isInferred ? formData.inferred[field] : get(this.props.fields, field),
            enabled: (this.props.enabled == null ||  this.props.enabled == true) && !isInferred,
            rules: formData.rules[field],
            show: formData.predicates[field],
            options: formData.options[field],
            errors: this.props.errors[field],
            type,
            clearFields: this.props.actions.clearFields,
            updateField: intercept
                ? (field, value) => this.props.actions.updateField(field, intercept(field, value))
                : this.props.actions.updateField
        }
        
        if(formData.predicates[field] == false) return null;

        if(childProps.options){
            if(childProps.options == YesNoOptions){
                return <YesNoInput { ...childProps } />
            }else if(childProps.options == CheckOptions){
                return <CheckBoxInput { ...childProps } />
            }else{
                if(this.props.multiselect){
                    return <MultiSelectionInput { ...childProps } />
                }else{
                    return <MultiSelectionInput { ...childProps } />
                }
            }
        }else{
            if( type == "PostcodeAuto" ){
                return <PostcodeAutoComplete { ...childProps } />
            }else if( type == "SuburbAuto" ){
                return <SuburbAutoComplete { ...childProps } />
            }else if( type == "Date") {
                return <DatePicker { ...childProps } />
            }else{
                return <StandardInput { ...childProps } />
            }
        }
    }

})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/input-field.tsx